var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"vbg-ff-content-container"},[_c('div',{staticClass:"tittle"},[_c('h2',{staticClass:"tittle"},[_vm._v(" "+_vm._s(_vm.$t("message.delivery_method_options_locked_tittle"))+" ")])]),_c('div',{staticClass:"sub-tittle"},[_c('p',{staticClass:"messageContentUn",domProps:{"innerHTML":_vm._s(_vm.otp_account_locked)}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }